import { autobind } from "core-decorators";

const digits = {
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9",
  "٫": ".",
};

const characters = {
  "ي": "ی",
  "ك": "ک",
  "دِ": "د",
  "بِ": "ب",
  "زِ": "ز",
  "ذِ": "ذ",
  "ِشِ": "ش",
  "ِسِ": "س",
  "ى": "ی",
};

@autobind
/**
 *
 */
export default class Transform {
  /**
   *
   * @param  {String} digit
   * @return {String}
   */
  static digit(digit) {
    return digit.replace(/([۰-۹٫])/g, (match) => digits[match]);
  }

  /**
   *
   * @param {String} value
   * @return {*}
   */
  static fa2en(value) {
    if (value) {
      return value.replace(/([۰-۹٫])/g, (match) => digits[match]);
    }

    return value;
  }

  /**
   *
   * @param {String} string
   * @return {String}
   * @static
   */
  static string(string) {
    return string ?
      string.replace(new RegExp(`(${characters.$keys().join("|")})`, "g"), (match) => characters[match]) :
      string;
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   * @static
   */
  static array(array) {
    return array.map(Transform.any);
  }

  /**
   *
   * @param {Object} object
   * @return {Object}
   * @static
   */
  static object(object) {
    return object.$mapValues(Transform.any);
    // const _result = {};

    // for (const key in object) {
    //   _result[key] = Transform.any(object[key]);
    // }

    // return _result;
  }

  /**
   *
   * @param {*} value
   * @return {*}
   * @static
   */
  static any(value) {
    switch (true) {
      case String.isString(value):
        return Transform.string(value);
      case Array.isArray(value):
        return Transform.array(value);
      case Object.isPlainObject(value):
        return Transform.object(value);
      default:
        return value;
    }
  }

  /**
   * camel case objects
   * @param {Object} object the object you want to make it camel cased
   * @return {Object} camel cased object
   * @static
   */
  static objectToCamel(object) {
    return object.$map((value, key) => ({ [key.camelCase()]: Transform.snakeToCamel(value) }));
    // const _result = {};

    // for (const key in object) {
    //   _result[key.camelCase()] = Transform.snakeToCamel(object[key]);
    // }

    // return _result;
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   * @static
   */
  static arrayToCamel(array) {
    return array.map(Transform.snakeToCamel);
  }

  /**
   *
   * @param {String|Object|Array} value
   * @return {*}
   * @static
   */
  static snakeToCamel(value) {
    switch (true) {
      case String.isString(value):
        return Transform.string(value);
      case Array.isArray(value):
        return Transform.arrayToCamel(value);
      case Object.isPlainObject(value):
        return Transform.objectToCamel(value);
      default:
        return value;
    }
  }

  /**
   *
   * @param {Object} object
   * @return {Object}
   * @static
   */
  static objectToSnake(object) {
    return object.$map((value, key) => ({ [key.snakeCase()]: Transform.camelToSnake(value) }));
    // const result = {};

    // for (const key in object) {
    //   result[key.snakeCase()] = Transform.camelToSnake(object[key]);
    // }

    // return result;
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   * @static
   */
  static arrayToSnake(array) {
    return array.map(Transform.camelToSnake);
  }

  /**
   *
   * @param {String|Object|Array} value
   * @return {*}
   * @static
   */
  static camelToSnake(value) {
    switch (true) {
      case String.isString(value):
        return Transform.string(value);
      case Array.isArray(value):
        return Transform.arrayToSnake(value);
      case Object.isPlainObject(value):
        return Transform.objectToSnake(value);
      default:
        return value;
    }
  }
}
